import { render, staticRenderFns } from "./CoverLetter_2.vue?vue&type=template&id=78558fd4&scoped=true&"
import script from "./CoverLetter_2.vue?vue&type=script&lang=js&"
export * from "./CoverLetter_2.vue?vue&type=script&lang=js&"
import style0 from "./CoverLetter_2.vue?vue&type=style&index=0&id=78558fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78558fd4",
  null
  
)

export default component.exports